// extracted by mini-css-extract-plugin
export default {"dialog-buy-loot-packs-picker__common-margin":"dialog-buy-loot-packs-picker__common-margin--2Lza4","dialog-buy-loot-packs-picker__discount-code":"dialog-buy-loot-packs-picker__discount-code--3HIJB","dialog-buy-loot-packs-picker__cta":"dialog-buy-loot-packs-picker__cta--UFsEC"};
    if(module.hot) {
      // 1747648163529
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  